import './article.css';
import React, { useState, useEffect } from 'react';
import ArticleCard from '../cards/articleCard.js';
import DocumentMeta from 'react-document-meta';
import ArticleMetaTags from './articleMetaTags.js'
import ArticleService from '../services/articleService/articleService';

function ArticleIterableCards() {
    const [articleDocs, setArticleDocs] = useState([]);
    const meta = ArticleMetaTags();
    const projectCollection = '/articles';
    const articleService = new ArticleService(projectCollection); // nosql database service
    const fetchArticleDocs = async ()=> {
    const data = await articleService.getData();
     setArticleDocs([...data])
   }

   useEffect(() => {
     fetchArticleDocs();
   }, [])

  return (
    <DocumentMeta {...meta}>
    <div>
    <div className="Article">
      <body className="Article-body">
      {
        articleDocs && articleDocs.map(value=>{
        return(
        <div className="Article-card">
        <ArticleCard
        title={value.title}
        description= {value.description}
        imageUrl={value.imageUrl}
        link={value.articleLink}
        alt={value.alt}/>
        </div>
      )
    }
    )
  }
      </body>
      <div className="Article-trademarks">
      <p > IEEE&copy; &nbsp; DEV&copy; &nbsp; MEDIUM&copy; &nbsp;logos are registered trademarks of those Organizations &nbsp;</p>
      <p > &copy; Copyright 2021 All rights reserved</p>
      </div>
    </div>
    </div>
    </DocumentMeta>
  );

}

export default ArticleIterableCards;

/*
<div className="Article-card">
<ArticleCard
title=" BALANCE: Link Flooding Attack Detection and Mitigation via Hybrid-SDN "
description= "Link Flooding Attack (LFA) is a genre of Distributed Denial
              of Service (DDoS) attack. LFA can cut off a target area from
              the network, without directly attacking the target.
              The attacker chooses links which when cut off will
              disconnect the target area and instruct the bots to flood
              those links with small packets. Some of the existing solutions
              are suitable for specific routing methods like shortest path
              routing or need cooperation between Autonomous Systems (AS).
              To overcome certain hitches of existing solutions,
              we have proposed a novel mechanism named BALANCE.
              It detects and mitigates LFA via hybrid-Software-Defined Network (SDN)."
imageUrl="https://upload.wikimedia.org/wikipedia/commons/thumb/5/56/Ieee_blue.jpg/800px-Ieee_blue.jpg"
link="https://ieeexplore.ieee.org/document/9099887"
alt="Dev"/>
</div>
*/
